import { Card, Box, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../images/machineImageEmpty.svg';
import { entityGridPhotoUrl } from '../entityImage/entityImageConfig';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import '../../css/users/usersCardViewData.css';

const UsersCardViewData = React.memo(({ index, style, data }) => {

    const { users, columns, filteredUsersCount } = data;
    const navigate = useNavigate();

    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredUsersCount);

    return (
        <Box style={style} key={index}>
            <Grid container spacing={2}>
                {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                    const userIndex = startIndex + idx;
                    const user = users[userIndex];
                    const imageUrl = entityGridPhotoUrl(user, 'user', { size: 'small' });

                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={user ? user.id : `skeleton-${userIndex}`}>
                            <Card className='usersCardViewData_card'>
                                <CardActionArea
                                    onClick={user ? () => navigate(`utilisateur_details/${user.id}`) : undefined}
                                >
                                    {user ? (
                                        <>
                                            <CardMedia
                                                component="img"
                                                image={imageUrl}
                                                alt=""
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '192px',
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 0,
                                                    objectFit: 'cover',
                                                    filter: 'blur(10px)',
                                                }}
                                                loading="lazy"
                                                decoding="async"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = machineDefaultImage;
                                                }}
                                            />

                                            {/* Main Image Over Content */}
                                            <CardMedia
                                                component="img"
                                                height="192"
                                                style={{
                                                    position: 'relative',
                                                    objectFit: imageUrl !== machineDefaultImage ? 'contain' : 'cover',
                                                    zIndex: 1
                                                }}
                                                image={imageUrl}
                                                alt={user?.name}
                                                loading="lazy"
                                                decoding="async"
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = machineDefaultImage;
                                                }}
                                            />

                                            <CardContent className='usersCardViewData_card_CardContent'>
                                                <Typography className='usersCardViewData_machine_name' component="div">{user?.first_name} {user?.last_name}</Typography>
                                                <Typography className='usersCardViewData_machine_mark' component="div">{user?.email}</Typography>
                                                <Typography className='usersCardViewData_machine_mark' component="div">{user?.role.name}</Typography>
                                                <Typography className='usersCardViewData_machine_mark' component="div">
                                                    {user?.user_region?.length > 0 ? (
                                                        <>
                                                            <Box className='usersCardViewData_machine_metier_Box'>
                                                                <Typography className='usersCardViewData_machine_metier' component="span">{user?.user_region[0]?.region?.name}</Typography>
                                                                {user?.user_region?.length > 1 && (
                                                                    <Typography className='usersCardViewData_machine_metier_length' component="span">+{user?.user_region?.length - 1}</Typography>
                                                                )}
                                                            </Box>
                                                        </>
                                                    ) : '--'}
                                                </Typography>
                                            </CardContent>
                                        </>
                                    ) : (
                                        <>
                                            <Skeleton variant="rectangular" height={192} />
                                            <CardContent className='usersCardViewData_card_CardContent'>
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                            </CardContent>
                                        </>
                                    )}
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
});

export default UsersCardViewData;